import React, { PureComponent, ReactElement } from 'react';
import Select from 'react-select';
import { SideBarProps } from '../types';

interface SelectedType {
  label: string;
  value: number;
}

interface TypeSidebarState {
  selected: SelectedType[];
}

export default class TypeSidebar extends PureComponent<SideBarProps, TypeSidebarState> {
  constructor(props: SideBarProps) {
    super(props);
    this.state = {
      selected: [],
    };
  }

  select = (selected: SelectedType[] = []): void => {
    if (selected === null) {
      selected = [];
    }
    this.props.fetchActivities({
      typeId: selected.map((o) => o.value),
    });
    this.setState({ selected });
  };

  render(): ReactElement {
    return (
      <div className="contextual-region block block-sidebar-first">
        <div className="block-title">
          <h3>
            <span className="disable-select">Typ</span>
          </h3>
        </div>

        <div className="block-content-outer">
          <div className="block-content">
            <Select
              isClearable
              isMulti
              onChange={this.select}
              value={this.state.selected}
              options={this.props.types.map((item) => ({
                label: item.label,
                value: item.id,
              }))}
              placeholder="Välj typ"
            />
          </div>
        </div>
      </div>
    );
  }
}
